export const APP_LOCALES = ["en", "el", "es", "de"] as const;

export type AppLocale = (typeof APP_LOCALES)[number];

export const DEFAULT_APP_LOCALE: AppLocale = "en";

export const APP_LOCALE_STORAGE_KEY = "app.locale";

/** Previous HelioTrace-only key; still read so existing preferences migrate. */
export const LEGACY_HELIOTRACE_LOCALE_STORAGE_KEY = "heliotrace.locale";

export type AppLocaleOption = {
  code: AppLocale;
  nativeName: string;
  englishName: string;
  /** Token used in assistant-service translation queries (single word). */
  translationTarget: string;
};

export const LOCALE_OPTIONS: ReadonlyArray<AppLocaleOption> = [
  { code: "en", nativeName: "English", englishName: "English", translationTarget: "english" },
  { code: "el", nativeName: "Ελληνικά", englishName: "Greek", translationTarget: "greek" },
  { code: "es", nativeName: "Español", englishName: "Spanish", translationTarget: "spanish" },
  { code: "de", nativeName: "Deutsch", englishName: "German", translationTarget: "german" },
];

export function isAppLocale(value: string | null | undefined): value is AppLocale {
  return value === "en" || value === "el" || value === "es" || value === "de";
}

export function localeHtmlLang(locale: AppLocale): string {
  return locale;
}

/** Language name in its own language, for status text shown in that language. */
export function localeNativeName(locale: AppLocale): string {
  return LOCALE_OPTIONS.find((option) => option.code === locale)?.nativeName ?? locale;
}

export function translationTargetForLocale(locale: AppLocale): string {
  return LOCALE_OPTIONS.find((option) => option.code === locale)?.translationTarget ?? "english";
}

/** English display name passed to generation prompts (`responseLanguage`). */
export function responseLanguageForLocale(locale: AppLocale): string | undefined {
  if (locale === "en") return undefined;
  return LOCALE_OPTIONS.find((option) => option.code === locale)?.englishName;
}
